import axios from 'axios'
import { AesUtil } from "./AESUtils";
import {
  serverIpAddress,
  httpTimeout
} from "./systemConfig";
import { localStorage } from "./localStorageModule.js";
import { Toast } from 'vant'
import router from "@/router/index.js";

var baseURL = process.env.NODE_ENV == 'development' ? '/apis' : serverIpAddress

axios.defaults.headers['Content-Type'] = 'application/json;multipart/form-data;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // baseURL: process.env.NODE_ENV == 'development'?process.env.VUE_APP_BASE_API:serverIpAddress,
  baseURL: baseURL,

  // 超时
  timeout: httpTimeout
})
// request拦截器
service.interceptors.request.use(config => {
  let tokenInfo = localStorage.$selectLocalStorage('tokenInfo')
  let headerToken = {}
  let locationData = {
    ip: window.Ip,
    timestamp: new Date().getTime()
  }
  let locationInfo = AesUtil.encryptionLoc(JSON.stringify(locationData)).text
  headerToken.location = locationInfo
  if(tokenInfo){
    headerToken.Authorization = tokenInfo
  }
  let formData = new FormData()
  if(config.data){
    formData.append('text', AesUtil.getAxiosJSONstr(config.data).text)
  }
  // 是否需要设置 token
  config.headers=headerToken// 让每个请求携带自定义token 请根据实际情况自行修改
  config.params = !config.params ? '': AesUtil.getAxiosJSONstr(config.params)
  config.data = formData
  return config
}, error => {
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    if(!res.data){
      return;
    }
    if(res.data) {
      let decodeData  = JSON.parse(AesUtil.getAxiosHeadJSONstr(res.data.data))
      res.data.data = decodeData
    }
    return res.data
  },
  error => {
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    }
    else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    }
    else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/util/request.js